import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Card } from '@wds/card';
import { Typography } from '@wds/typography';
import { Link } from '@wds/link';
import CategoriesContext from '~app/pages/AppsDirectory/components/CategoriesContext';
import AppPlaceHolderImg from '~app/pages/AppsDirectory/static/images/app-placeholder.png';

import './app-card.scss';

const AppCard = ({ app }) => {
  const { isLoading, categories = [] } = useContext(CategoriesContext);

  const renderAppCategory = appCategoryId => {
    const matchedCategory = categories.filter(cat => cat.id === appCategoryId.toString())[0];

    return (
      <If condition={matchedCategory} key={appCategoryId}>
        <Typography color="darkMuted">
          <span className="sm-app-card__app-category" data-testid="AppCard__Category">
            {matchedCategory.title}
          </span>
        </Typography>
      </If>
    );
  };

  return (
    <Box mb={5} data-testid="AppCard__Col" key={app.encryptedAppId}>
      <Link key={app.encryptedAppId} href={app.link} underline="false">
        <Card>
          <img src={app.image ? app.image : AppPlaceHolderImg} alt={app.name} className="sm-app-card__app-logo" />
          <Typography>{app.name}</Typography>
          <Typography>{app.tagline}</Typography>
          {app.categories.length && !isLoading && app.categories.map(catId => renderAppCategory(catId))}
        </Card>
      </Link>
    </Box>
  );
};

AppCard.propTypes = {
  app: PropTypes.shape({
    encryptedAppId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
};

export default AppCard;
